import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;

new Vue({
  async created() {
    // catch the install prompt, so we can show the toast later
    window.addEventListener('beforeinstallprompt', (prompt) => {
      prompt.preventDefault();
      this.$store.commit('setInstallPrompt', prompt);
    });
    // load data from db and initialise state with it
    await this.$store.dispatch('loadDataFromDB');
  },
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
